module.exports = {
  TOKEN_KEY: 'auth-token',
  JWT_EXPIRY: process.env.JWT_EXPIRY || '20s',
  API_ENDPOINT: `https://mysterious-hamlet-31385.herokuapp.com/api`
}
